<template>
  <div class="dashboard-editor-container">
    <el-row>
      <el-col :xs="24" :sm="4" :md="4">
        <pan-thumb class="panthumb" :image="profile_pic_url" style="float: left">
          Your role of the system is:
          <span v-for="item in roles" :key="item" class="pan-info-roles">{{ item }}</span>
        </pan-thumb>
      </el-col>
      <el-col :xs="24" :sm="20" :md="20">
          <div class="display_name">{{ name }}</div>
          <div style="font-size:20px;padding-top:20px;display:inline-block;">JiangChinese VIP</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PanThumb from '@/components/PanThumb'

export default {
  name: 'DashboardEditor',
  components: { PanThumb },
  data() {
    return {
      emptyGif: 'https://wpimg.wallstcn.com/0e03b7da-db9e-4819-ba10-9016ddfdaed3'
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'profile_pic_url',
      'roles'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .emptyGif {
    display: block;
    width: 45%;
    margin: 0 auto;
  }

  .dashboard-editor-container {
    background-color: #e3e3e3;
    min-height: 100vh;
    padding: 50px 60px 0px;
    .panthumb {
      margin-bottom: 20px;
    }
    .pan-info-roles {
      font-size: 12px;
      font-weight: 700;
      color: #333;
      display: block;
    }
    .display_name {
        margin-top: 20px;
        font-size: 48px;
        line-height: 48px;
        color: #212121;
      }
  }
</style>
